<template>
    <v-container class="pa-0 profile-content">

        <!-- AVATAR -->
        <profile-avatar class="profile-avatar-block" :img="avatarImg" :name="account && account.name" :size="100" />

        <!-- STATS -->
        <div class="profile-stats">
            <div class="stat-cell">
                <div class="stat-icon-row">
                    <v-icon size="16" color="txtMuted">mdi-account-multiple-outline</v-icon>
                    <span class="stat-value">{{ activeStudents }}</span>
                </div>
                <div class="stat-label">{{ $t('common.actives') }}</div>
            </div>
            <div class="stat-cell">
                <div class="stat-icon-row">
                    <v-icon size="16" color="txtMuted">mdi-star-outline</v-icon>
                    <span class="stat-value">{{ coachStars.toFixed(1).replace('.0', '') }}</span>
                </div>
                <div class="stat-label">{{ $t('coach.assess') }}</div>
            </div>
        </div>

        <!-- NAME + DESCRIPTION -->
        <div class="profile-name-wrap">
            <div class="profile-name">{{ account && account.name || $t('common.no_name') }}</div>
            <button-tooltip @click="editBasicInfo" icon top :tooltip="$t('common.edit')"
                buttonClass="edit-name-btn">
                <v-icon size="15">mdi-square-edit-outline</v-icon>
            </button-tooltip>
        </div>
        <div class="profile-desc">{{ account && account.description || $t('common.no_description') }}</div>

        <edit-personal-info-dialog ref="personalInfo" />
    </v-container>
</template>

<script>

import ProfileAvatar from '@/components/common/ProfileAvatar'
import EditPersonalInfoDialog from '@/components/common/EditPersonalInfoDialog'
import ButtonTooltip from '@/components/common/ButtonTooltip'

export default {
    components: {
        ProfileAvatar,
        EditPersonalInfoDialog,
        ButtonTooltip,
    },
    computed: {
        avatarImg(vm = this) {
            return vm.account?.avatar || null
        },
        activeStudents(vm = this) {
            return vm.account?.activeStudents || 0
        },
        coachStars(vm = this) {
            return vm.account?.rating?.stars || 0
        },
    },
    methods: {
        editBasicInfo() {
            const vm = this
            vm.$refs.personalInfo.show()
        },
    },
}
</script>

<style scoped>

.profile-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 32px;
}

/* Foto */
.profile-avatar-block {
    margin-bottom: 24px;
}

/* Stats */
.profile-stats {
    display: flex;
    width: 100%;
    max-width: 480px;
    border: 1px solid var(--v-outline-base);
    border-radius: 12px;
    overflow: hidden;
    background: var(--v-surface-base);
    margin-bottom: 24px;
}

.stat-cell {
    flex: 1;
    padding: 14px 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.stat-cell + .stat-cell {
    border-left: 1px solid var(--v-outline-base);
}

.stat-icon-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.stat-value {
    font-size: 20px;
    font-weight: 800;
    color: var(--v-txtPrimary-base);
}

.stat-label {
    font-size: 12px;
    color: var(--v-txtMuted-base);
    font-weight: 500;
}

/* Nombre / descripción */
.profile-name-wrap {
    width: 100%;
    max-width: 480px;
    position: relative;
    margin-bottom: 8px;
}

.profile-name {
    font-size: 22px;
    font-weight: 800;
    color: var(--v-txtPrimary-base);
    text-align: center;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--v-primary-base);
}

.theme--light .profile-name {
    border-color: var(--v-accent-base);
}

.profile-content >>> .edit-name-btn {
    position: absolute;
    right: 0;
    top: 0;
    width: 28px !important;
    height: 28px !important;
    color: var(--v-txtMuted-base) !important;
}

.profile-desc {
    font-size: 13px;
    color: var(--v-txtMuted-base);
    text-align: center;
    margin-top: 10px;
}

</style>
